import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div`
  position: relative;
`;

export const TriggerButton = styled.button`
  all: unset;
  box-sizing: border-box;

  width: auto;
  height: 42px;
  min-width: ${props => props.compact ? "5.5rem" : "auto"};

  gap: 8px;
  display: inline-flex;
  align-items: center;
  ${props => props.compact && "justify-content: center;"}

  padding: ${props => props.customPadding ? props.customPadding : "10px 16px"};
  border-radius: 10rem;
  white-space: nowrap;
  cursor: pointer;

  background-color: ${props => props.hasSelection ? "#2fbb691f": theme.colors.white.Branco};
  border: 1px solid ${props => props.hasSelection
    ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_2};

  transition: border-color .15s ease;
`;

export const Badge = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 5px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 999px;
  background-color: ${theme.colors.green.Verde_AgroReceita};

  font-family: Lato;
  font-size: 11px;
  font-weight: 800;
  color: ${theme.colors.white.Branco};
`;

export const Chevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  transform: rotate(${props => props.open ? "180deg" : "0deg"});
  transition: transform .2s ease;

  svg {
    display: block;
  }
`;

export const Panel = styled.div`
  position: absolute;
  left: ${props => props.openLeft ? "auto" : "0"};
  right: ${props => props.openLeft ? "0" : "auto"};
  top: ${props => props.openUp ? "auto" : "calc(100% + 8px)"};
  bottom: ${props => props.openUp ? "calc(100% + 8px)" : "auto"};
  z-index: 1000;

  width: 230px;
  max-width: 90vw;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 10px;
  border-radius: 16px;
  background-color: ${theme.colors.white.Branco};
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.16);
`;

export const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;

  border-radius: 10px;
  border: 1px solid ${theme.colors.gray.Cinza_2};
  outline: none;

  font-family: Lato;
  font-size: 13px;
  color: ${theme.colors.gray.Cinza_2};

  &::placeholder {
    color: ${theme.colors.gray.Cinza_7};
  }
`;

export const OptionsList = styled.div`
  max-height: ${props => props.maxHeight || "180px"};
  overflow-y: auto;

  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray.Cinza_10};
    border-radius: 999px;
  }
`;

export const OptionRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 6px 6px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: ${theme.colors.gray.Cinza_13};
  }
`;

export const OptionLeft = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const OptionLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-family: Lato;
  font-size: 13px;
  font-weight: 600;
  color: ${theme.colors.gray.Cinza_2};
`;

export const OptionCount = styled.span`
  flex-shrink: 0;

  font-family: Lato;
  font-size: 12px;
  font-weight: 700;
  color: ${theme.colors.gray.Cinza_7};
`;


export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding-top: 8px;
  border-top: 1px solid ${theme.colors.gray.Cinza_12};
`;

export const FooterButtonWrap = styled.div`
  flex: 1;
`;
